import MultiStepForm from '@/components/forms/MultiStepForm';
import GeneralUserSubscriptions from '@/components/forms/apps/GeneralUserSubscriptions';
import ColorPickerForm from '@/components/forms/apps/ColorPickerForm';
import LinkForm from '@/components/forms/apps/pass/LinkForm';
import RedirectUriForm from '@/components/forms/apps/RedirectUriForm';
import tenant from '@/services/TenantService';
import { toast } from 'react-toastify';
import ToastMessage from '@/components/toasts/ToastMessage';

export default function PassSetup({ app, onFinish, onCancel, deployment }) {
  const depl = deployment || {};
  const steps = [
    <ColorPickerForm key="themeColor" app={app} />,
    <LinkForm key="link" app={app} />,
    <RedirectUriForm key="redirectUri" app={app} />,
    <GeneralUserSubscriptions key="userSubcriptions" app={app} />,
  ];

  const handleSubmit = async (formData, users) => {
    const { redirectUri, ...configData } = formData;
    const deploymentData = {
      app: app._id,
      config: configData,
      redirectUri,
    };

    let token;
    let tokenId;
    try {
      const roleResponse = await tenant.post('/role', {
        name: 'Pass-Tool',
        description: 'Pass-Tool App',
        permissions: {
          secret: {
            read: true,
            create: true,
          },
          file: {
            read: true,
            create: true,
            update: true,
          },
          user: {
            read: true,
          },
        },
      });

      if (!roleResponse.status === 201) {
        toast.error(
          <ToastMessage
            title="Fehler"
            subtitle={
              roleResponse?.response?.data?.message ||
              'Fehler beim Erstellen der Konfiguration1'
            }
          />,
        );
        return;
      }

      const roleId = roleResponse.data.insertedId;
      deploymentData.config.token = '';

      const deploymentResponse = await tenant.put(
        `/deployment/${depl.insertedId}`,
        deploymentData,
      );
      const { deployment } = deploymentResponse.data;

      const tokenResponse = await tenant.post('/token', {
        title: 'Pass-Tool Token',
        description: 'Token für die Pass-Tool App',
        scope: ['secret.all', 'file.all', 'user.read'],
        roleId,
        deploymentId: depl.insertedId,
      });

      if (!tokenResponse.status === 201) {
        try {
          await tenant.delete(`role/${roleId}`);
        } catch (error) {
          toast.error(
            <ToastMessage
              title="Fehler"
              subtitle={
                error?.response?.data?.message ||
                'Fehler beim Erstellen der Konfiguration2'
              }
            />,
          );
          return;
        }
      }

      token = tokenResponse.data.token;
      tokenId = tokenResponse.data._id;

      deploymentData.config.token = token;

      await tenant.put(`/deployment/${depl.insertedId}`, deploymentData);

      await tenant.post('/subscription', {
        userIds: users,
        deploymentId: depl.insertedId,
      });

      onFinish(deployment, users);
    } catch (error) {
      try {
        await tenant.delete(`token/${tokenId}`);
      } catch (error) {
        toast.error(
          <ToastMessage
            title="Fehler"
            subtitle={
              error?.response?.data?.message ||
              'Fehler beim Erstellen der Konfiguration3'
            }
          />,
        );
      }
      toast.error(
        <ToastMessage
          title="Fehler"
          subtitle={
            error?.response?.data?.message ||
            'Fehler beim Erstellen der Konfiguration4'
          }
        />,
      );
    }
  };

  return (
    <MultiStepForm steps={steps} onSubmit={handleSubmit} onCancel={onCancel} />
  );
}
